/**
 * Created by ctleake on 12/07/2024.
 */

var Peep = {

    init: function() {
        Peep.bindSelectPupil();
    },

    bindSelectPupil: function() {
        $('#iep-pupil').on('select2:select', function() {
            var pupilId = $(this).val();
            $.get('/peeps/get-pupil-photo/' + pupilId, function(data) {
                var photoId = JSON.parse(data).results[0].file_id;
                $('#file').prop('src', '/files/' + photoId);
            });
            $.get('/peeps/get-pupil-class/' + pupilId, function(data) {
                var tutorGroupId = data;
                $('#peep-tutor-group').val(tutorGroupId);
                $('#peep-tutor-group').trigger('change');
            });
        });
    },

};